module.exports = __webpack_public_path__ + "img/icone-coa-sensor.15cbea8d.svg";